import React from 'react'
import classNames from 'classnames'

import './styles.css'

const HeaderTabs = ({ setHash, hash }) => {
  return (
    <nav className="w-100 w-60-m mw617 order-3 order-2-m">
      <ul className="list flex items-center">
        <Tab to={() => setHash('home')} name="Home" isActive={hash === 'home'}>
          <path
            d="M10.458 3C10.086 3 3 9.897 3 10.308V17h5.71s-.022-3.448-.022-4.599c0-.55.407-1.313 1.812-1.313 1.32 0 1.727.934 1.727 1.283V17H18v-6.61C18 9.897 10.78 3 10.458 3z"
            stroke="currentColor"
            strokeWidth=".8"
          />
        </Tab>
        <Tab
          to={() => setHash('vote')}
          name="Vote"
          isActive={hash === 'vote'}
        >
          <path
            d="M5.633 16.37c.065-.361.127-.743.193-1.124.185-1.055.369-2.111.56-3.16.015-.096-.014-.15-.076-.212a893.568 893.568 0 01-2.506-2.387c-.198-.188-.388-.373-.585-.556-.19-.18-.27-.4-.185-.645.083-.256.287-.373.552-.408 1.428-.205 2.854-.406 4.281-.614.06-.01.133-.085.162-.147.637-1.247 1.262-2.491 1.89-3.74.153-.304.402-.427.729-.359.214.043.343.185.436.37.627 1.241 1.251 2.482 1.878 3.729.048.1.107.144.228.16 1.42.197 2.843.4 4.264.602.254.037.443.172.52.417.074.249-.013.462-.2.64-.908.864-1.81 1.728-2.716 2.59-.104.097-.2.205-.31.292-.125.096-.149.198-.125.352.248 1.358.482 2.72.722 4.08.046.263-.016.482-.237.639-.219.155-.449.136-.684.015-1.248-.642-2.501-1.287-3.753-1.935-.121-.064-.212-.071-.337-.005-1.242.645-2.485 1.284-3.73 1.925-.211.111-.421.161-.643.041-.222-.115-.32-.3-.328-.56"
            stroke="currentColor"
            strokeWidth=".8"
          />
        </Tab>
        <Tab
          to={() => setHash('shop')}
          name="Shop"
          isActive={hash === 'shop'}
          viewBox="0 0 26 26"
        >
          <g fill="none" fillRule="evenodd">
            <path d="M12.341 11.794l-4.294.001c-.274 0-.522.041-.527-.383-.005-.43.216-.444.542-.443 2.863.006 5.726.008 8.589-.002.352-.002.507.059.51.462.002.45-.27.364-.525.364-1.432.002-2.863.001-4.295.001m-1.309 1.849c-1.016 0-2.033-.012-3.05.006-.358.006-.462-.127-.462-.466 0-.34.159-.406.458-.405 2.054.007 4.108.01 6.162-.002.337-.002.423.131.422.436-.001.3-.073.443-.418.437-1.037-.018-2.074-.006-3.112-.006m-1.337 1.734c-.58 0-1.159-.009-1.738.004-.314.007-.445-.101-.437-.425.008-.282.04-.463.396-.46 1.2.013 2.4.015 3.6 0 .357-.005.39.166.395.45.005.308-.082.446-.416.436-.6-.017-1.2-.005-1.8-.005" fill="currentColor" />
            <path d="M5.795 18.144c-.726.017-1.386-.6-1.384-1.296a1.306 1.306 0 011.3-1.296c.8-.013 1.357.512 1.359 1.278a1.283 1.283 0 01-1.275 1.314zm7.886-2.592c.72-.011 1.348.548 1.381 1.231.034.69-.603 1.344-1.327 1.362-.719.017-1.396-.623-1.383-1.308.013-.695.612-1.275 1.329-1.285M3.144 1.744c-.583-.002-1.168.007-1.751-.006-.263-.005-.52-.077-.494-.411.023-.286.218-.432.506-.434a456.45 456.45 0 013.379 0c.367.001.509.216.518.55.012.426-.316.29-.531.296-.542.015-1.084.005-1.627.005zm19.836 3.66c.085-1.47-.36-1.933-1.854-1.934h-.817c-4.503 0-9.007-.007-13.51.01-.49.002-.67-.116-.624-.606.045-.487.018-.98.01-1.47C6.17.578 5.669.044 4.835.026a64.019 64.019 0 00-3.393.005C1 .045.55.182.268.57c-.3.413-.364.863-.112 1.326.245.45.624.708 1.157.71 1.089.005 2.18.045 3.267-.013.638-.034.724-.145.734.75.01.897.01.897.02 1.345-.01.305-.005.612-.034.915-.034.353.117.452.467.45 3.68-.009 7.36-.008 11.04 0 .309 0 .425-.064.444-.399.027-.476-.24-.463-.58-.462-3.282.006-6.564.003-9.847.003-.306 0-.657.074-.667-.398.01-.147.018-.294.027-.442a.165.165 0 00.097-.04c4.99.004 9.98.014 14.969.004.552-.001.903.117.885.724-.007.325-.044.652-.013.974.076.793-.253 1.349-.914 1.8-.902.619-1.761 1.295-2.64 1.946-.841.604-1.702 1.186-2.52 1.82-.488.378-1.003.527-1.619.522-2.449-.017-4.899-.008-7.348-.006-1.347.001-1.775.418-1.778 1.712-.001.306-.01.612-.016.918-1.179.412-1.822 1.248-1.734 2.254.088 1.01.799 1.772 1.841 1.974 1.006.195 1.861-.282 2.422-1.403.132-.265.304-.284.545-.283.858.005 1.716.016 2.574-.004.39-.009.611.055.789.473.466 1.097 1.802 1.543 2.896 1.047 1.098-.496 1.579-1.694 1.115-2.772-.473-1.1-1.76-1.623-2.891-1.151-.56.233-.978.631-1.179 1.204-.094.271-.24.371-.542.365a86.849 86.849 0 00-2.825-.003c-.238.003-.391-.049-.47-.289-.262-.794-.883-1.204-1.659-1.441.003-.245.008-.49.01-.734.002-.964.032-.994 1.025-.995 2.467 0 4.935-.002 7.402.003.534 0 1.06-.056 1.494-.37 1.19-.86 2.363-1.744 3.543-2.619.061-.055 0 0 .09-.055.803-.58 1.61-1.15 2.406-1.74.507-.375.785-.897.841-1.507.04-.423.003-.852 0-1.278L6.113 3.875" fill="currentColor" mask="url(#prefix__prefix__b)" transform="translate(2 4)" />
          </g>
        </Tab>
        <Tab
          to={() => setHash('extra')}
          name="Extra"
          isActive={hash === 'extra'}
        >
          <path
            d="M9.427 5.027c-5.3-3.723-7.888 3.603-4.435 7.256l4.783 5.652c0 .01.299.316.563.015l5.464-5.67c3.831-4.234-.62-10.408-4.438-7.257-.982 1.108-1.937.004-1.937.004"
            stroke="currentColor"
            strokeWidth=".8"
            strokeLinecap="round"
            strokeLinejoin="bevel"
          />
        </Tab>
      </ul>
    </nav>
  )
}

export default HeaderTabs

const Tab = ({ children, to, name, height, isActive, viewBox }) => (
  <li className="flex-grow-1 flex-shrink-1 flex-basis-0">
    <button
      onClick={to}
      className={classNames({
        'white db ph2 pv3 no-underline tab-link pointer': true,
        'bg-transparent bw0 w-100 outline-0 relative': true,
        'tab-link--active': isActive
      })}
    >
      <svg
        viewBox={viewBox || `0 0 21 21`}
        xmlns="http://www.w3.org/2000/svg"
        className="w-auto h28 db center mb2"
        fill="none"
        fillRule="evenodd"
        style={{ height }}
      >
        {children}
      </svg>
      <div className="f12">{name}</div>
    </button>
  </li>
)
